import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  class: "flex flex-col flex-1 relative gap-4",
  style: {"height":"100vh"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex min-h-9 items-center flex-row gap-2 lg:pt-4"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "isolate inline-flex rounded-md shadow-sm font-medium" }
const _hoisted_6 = {
  key: 0,
  class: "flex-row gap-2 hidden lg:flex"
}
const _hoisted_7 = { class: "py-1 divide-y" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, " PDF ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, " Excel ", -1)
const _hoisted_11 = ["checked"]
const _hoisted_12 = {
  key: 1,
  class: "flex lg:hidden gap-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-0 bg-white opacity-60",
  style: {"z-index":"9998"}
}, null, -1)
const _hoisted_14 = {
  class: "absolute inset-0 flex items-center justify-center",
  style: {"z-index":"9999"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MinusIcon = _resolveComponent("MinusIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_ArrowUturnLeftIcon = _resolveComponent("ArrowUturnLeftIcon")!
  const _component_ArrowUturnRightIcon = _resolveComponent("ArrowUturnRightIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_EllipsisVerticalIcon = _resolveComponent("EllipsisVerticalIcon")!
  const _component_ArrowUpTrayIcon = _resolveComponent("ArrowUpTrayIcon")!
  const _component_ArrowDownTrayIcon = _resolveComponent("ArrowDownTrayIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_ModalTW = _resolveComponent("ModalTW")!
  const _component_LoadingSection = _resolveComponent("LoadingSection")!
  const _component_NoDataYet = _resolveComponent("NoDataYet")!
  const _component_bryntum_scheduler_pro = _resolveComponent("bryntum-scheduler-pro")!
  const _component_EventEditor = _resolveComponent("EventEditor")!
  const _component_NotificationsTW = _resolveComponent("NotificationsTW")!
  const _component_PdfExportModal = _resolveComponent("PdfExportModal")!
  const _component_MilestonePlotModal = _resolveComponent("MilestonePlotModal")!
  const _component_ProcessSideBar = _resolveComponent("ProcessSideBar")!
  const _component_ActualSideBar = _resolveComponent("ActualSideBar")!
  const _component_NavigationComponent = _resolveComponent("NavigationComponent")!

  return (_openBlock(), _createBlock(_component_NavigationComponent, {
    activeTag: _ctx.$t('app_features.planner')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_PageHeader, null, {
          content: _withCtx(() => [
            (!_ctx.noData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.zoomOut())),
                      type: "button",
                      class: "relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-500 hover:text-yellow focus:z-10"
                    }, [
                      _createVNode(_component_MinusIcon, {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ]),
                    _createElementVNode("input", {
                      type: "range",
                      min: "0",
                      max: "7",
                      class: "h-4 w-30 rounded bg-yellow-200 focus:bg-gray-300 hidden sm:block",
                      value: _ctx.presetIndex,
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRangeChange && _ctx.handleRangeChange(...args)))
                    }, null, 40, _hoisted_4),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomIn())),
                      type: "button",
                      class: "relative -ml-px inline-flex items-center rounded-r-md px-2 py-2 text-gray-500 hover:text-yellow focus:z-10"
                    }, [
                      _createVNode(_component_PlusIcon, {
                        class: "h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_5, [
                    (_ctx.currentMode === 'revision')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.undoChange && _ctx.undoChange(...args))),
                          type: "button",
                          class: "inline-flex items-center rounded-l-md border border-gray-300 bg-white p-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 capitalize"
                        }, [
                          _createVNode(_component_ArrowUturnLeftIcon, {
                            class: "h-5 w-5",
                            "aria-hidden": "true"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentMode === 'revision')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redoChange && _ctx.redoChange(...args))),
                          type: "button",
                          class: "inline-flex items-center rounded-r-md border border-gray-300 bg-white p-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 capitalize"
                        }, [
                          _createVNode(_component_ArrowUturnRightIcon, {
                            class: "h-5 w-5",
                            "aria-hidden": "true"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Menu, { as: "div" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MenuButton, {
                        type: "button",
                        class: "inline-flex items-center rounded-md border border-gray-300 bg-white py-2 pl-3 pr-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 capitalize"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`analytics.planner.modes.${_ctx.currentMode}`)) + " ", 1),
                          _createVNode(_component_ChevronDownIcon, {
                            class: "ml-2 h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_MenuItems, { class: "absolute right-50 z-50 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg focus:outline-none" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (mode) => {
                            return (_openBlock(), _createBlock(_component_MenuItem, {
                              key: mode,
                              onClick: ($event: any) => (_ctx.changeMode(mode)),
                              class: "capitalize"
                            }, {
                              default: _withCtx(({ active }) => [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: _normalizeClass([
                      active ? 'bg-gray-100 text-yellow-600' : 'text-gray-700',
                      'block px-4 py-2 text-sm',
                    ])
                                }, _toDisplayString(_ctx.$t(`analytics.planner.modes.${mode}`)), 3)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.currentMode === 'revision' && _ctx.hasChanges)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "focus:outline-none inline-flex items-center rounded-md border border-transparent font-medium shadow-sm px-4 py-2 text-sm bg-yellow-600 hover:bg-yellow-700 focus:ring-transparent text-white",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createNewRevision && _ctx.createNewRevision(...args)))
                        }, _toDisplayString(_ctx.$t("buttons.save")), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "focus:outline-none inline-flex items-center rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 font-medium shadow-sm px-4 py-2 text-sm focus:ring-transparent",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.revertChangesWithConfirmation && _ctx.revertChangesWithConfirmation(...args)))
                        }, _toDisplayString(_ctx.$t("buttons.cancel")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Menu, {
                    as: "div",
                    class: "inline-block text-left leading-none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MenuButton, { class: "flex items-center rounded-full text-gray-500 hover:text-gray-600" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EllipsisVerticalIcon, {
                            class: "h-8 w-8",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100",
                        "enter-from-class": "transform opacity-0 scale-95",
                        "enter-to-class": "transform opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75",
                        "leave-from-class": "transform opacity-100 scale-100",
                        "leave-to-class": "transform opacity-0 scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MenuItems, { class: "absolute right-5 z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray/5 focus:outline-none" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_MenuItem, {
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clickPlannerImport()))
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("button", {
                                      type: "button",
                                      disabled: !_ctx.canImport,
                                      class: _normalizeClass([
                          active && _ctx.canImport ? 'bg-gray-100 text-gray-900' : '',
                          'extraMenuItem',
                          _ctx.canImport ? ' text-gray-700' : 'text-gray-300',
                        ])
                                    }, [
                                      _createVNode(_component_ArrowUpTrayIcon, {
                                        class: "h-4 inline-flex mr-2",
                                        "aria-hidden": "true"
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("buttons.import")), 1)
                                    ], 10, _hoisted_8)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_MenuItem, { as: "template" }, {
                                  default: _withCtx(({ active }) => [
                                    _createVNode(_component_Menu, {
                                      as: "div",
                                      class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'extraMenuItem',
                        ])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_MenuButton, { class: "flex items-center w-full justify-between rounded-ful" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              _createVNode(_component_ArrowDownTrayIcon, {
                                                class: "h-4 inline-flex mr-2",
                                                "aria-hidden": "true"
                                              }),
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("buttons.export_plain")), 1)
                                            ]),
                                            _createVNode(_component_ChevronRightIcon, { class: "h-4" })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_Transition, {
                                          "enter-active-class": "transition ease-out du ration-100",
                                          "enter-from-class": "transform opacity-0 scale-95",
                                          "enter-to-class": "transform opacity-100 scale-100",
                                          "leave-active-class": "transition ease-in duration-75",
                                          "leave-from-class": "transform opacity-100 scale-100",
                                          "leave-to-class": "transform opacity-0 scale-95"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_MenuItems, { class: "absolute right-64 mr-2 z-10 w-1/2 origin-right rounded-md bg-white shadow-lg ring-1 ring-gray/5 focus:outline-none" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_MenuItem, {
                                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (this.isPdfExportModalOpen = true))
                                                }, {
                                                  default: _withCtx(({ active }) => [
                                                    _createElementVNode("a", {
                                                      href: "#",
                                                      class: _normalizeClass([
                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                  'group flex items-center px-4 py-2 text-sm',
                                ])
                                                    }, [
                                                      _createVNode(_component_font_awesome_icon, {
                                                        icon: "fa-solid fa-file-pdf",
                                                        class: "h-4 text-red"
                                                      }),
                                                      _hoisted_9
                                                    ], 2)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_MenuItem, { onClick: _ctx.exportXlsx }, {
                                                  default: _withCtx(({ active }) => [
                                                    _createElementVNode("a", {
                                                      href: "#",
                                                      class: _normalizeClass([
                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                  'group flex items-center px-4 py-2 text-sm',
                                ])
                                                    }, [
                                                      _createVNode(_component_font_awesome_icon, {
                                                        icon: "fa-solid fa-file-excel",
                                                        class: "h-4 text-green"
                                                      }),
                                                      _hoisted_10
                                                    ], 2)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_MenuItem, null, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("button", {
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openMilestonePlot())),
                                      type: "button",
                                      class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'extraMenuItem',
                        ])
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("milestone_plot.title")), 1)
                                    ], 2)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_MenuItem, null, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("button", {
                                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleCriticalPathVisibility && _ctx.toggleCriticalPathVisibility(...args))),
                                      type: "button",
                                      class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'extraMenuItem',
                        ])
                                    }, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: _ctx.isDependencyFeatureEnabled,
                                        class: "h-4 w-4 rounded border-gray-300 text-orange-400 focus:bg-gray-50 pointer-events-none mr-2"
                                      }, null, 8, _hoisted_11),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("analytics.planner.critical_path")), 1)
                                    ], 2)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.currentMode === 'visitor')
                                  ? (_openBlock(), _createBlock(_component_MenuItem, { key: 0 }, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("button", {
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isFullScheduleShown = !_ctx.isFullScheduleShown)),
                                          type: "button",
                                          class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'extraMenuItem',
                        ])
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isFullScheduleShown) = $event)),
                                            class: "h-4 w-4 rounded border-gray-300 text-orange-400 focus:bg-gray-50 pointer-events-none mr-2"
                                          }, null, 512), [
                                            [_vModelCheckbox, _ctx.isFullScheduleShown]
                                          ]),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("analytics.planner.show_complete_planner")), 1)
                                        ], 2)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentMode === 'revision' && _ctx.hasChanges)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "focus:outline-none inline-flex items-center rounded-md border border-transparent font-medium shadow-sm px-4 py-2 text-sm bg-yellow-600 hover:bg-yellow-700 focus:ring-transparent text-white",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.createNewRevision && _ctx.createNewRevision(...args)))
                  }, _toDisplayString(_ctx.$t("buttons.save")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "focus:outline-none inline-flex items-center rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 font-medium shadow-sm px-4 py-2 text-sm focus:ring-transparent",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.revertChangesWithConfirmation && _ctx.revertChangesWithConfirmation(...args)))
                  }, _toDisplayString(_ctx.$t("buttons.cancel")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("analytics.planner.title")) + " ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ModalTW, {
          open: _ctx.openImportModal && !_ctx.loading,
          onOnCloseModal: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openImportModal = false)),
          customCls: "sm:w-1/2 w-1/4 pt-24 pb-32"
        }, {
          content: _withCtx(() => [
            _createVNode(_component_FileInput, {
              onUpdateFile: _cache[15] || (_cache[15] = ($event: any) => (_ctx.importPlanner($event))),
              class: "w-5/6 mx-auto my-4"
            })
          ]),
          _: 1
        }, 8, ["open"]),
        (_ctx.loading || _ctx.isProjectDurationSettingsLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_LoadingSection, { loading: true })
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.noData && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_NoDataYet, {
              key: 1,
              feature: "planner",
              onImportPlanner: _cache[17] || (_cache[17] = ($event: any) => (_ctx.importPlanner($event)))
            }))
          : (_openBlock(), _createBlock(_component_bryntum_scheduler_pro, _mergeProps({
              ref: "schedulerProRef",
              key: _ctx.schedulerProKey,
              resources: _ctx.initialSchedulerProData?.resources,
              events: _ctx.initialSchedulerProData?.events,
              dependencies: _ctx.initialSchedulerProData?.dependencies
            }, _ctx.schedulerProConfig, {
              onBeforeEventAdd: _cache[18] || (_cache[18] = ($event: any) => (_ctx.beforeEventAddHandler($event))),
              onBeforeEventEdit: _cache[19] || (_cache[19] = ($event: any) => (_ctx.beforeEventEditHandler($event))),
              onEventClick: _ctx.handleEventClick,
              onEventDblClick: _ctx.handleEventDblClick,
              onDataChange: _ctx.updateHasChanges,
              onCellDblClick: _ctx.handleCellDblClick,
              onCellClick: _ctx.handleCellClick,
              onWheel: _ctx.handleWheel,
              eventMenuFeature: {
          ...(_ctx.schedulerProConfig?.eventMenuFeature ? _ctx.schedulerProConfig.eventMenuFeature : {}),
          items: {
            ...(_ctx.schedulerProConfig.eventMenuFeature?.items
              ? _ctx.schedulerProConfig.eventMenuFeature.items
              : {}),
            showProcesses:
              _ctx.currentMode === 'visitor'
                ? {
                    ...(_ctx.schedulerProConfig.eventMenuFeature?.items?.showProcesses
                      ? _ctx.schedulerProConfig.eventMenuFeature.items.showProcesses
                      : {}),
                    onItem: _ctx.showProcessesOnEventClick,
                  }
                : false,
            hideProcesses:
              _ctx.currentMode === 'visitor'
                ? {
                    ...(_ctx.schedulerProConfig.eventMenuFeature?.items?.hideProcesses
                      ? _ctx.schedulerProConfig.eventMenuFeature.items.hideProcesses
                      : {}),
                    onItem: _ctx.hideProcessesOnEventClick,
                  }
                : false,
          },
        },
              scheduleMenuFeature: {
          ...(_ctx.schedulerProConfig?.scheduleMenuFeature
            ? _ctx.schedulerProConfig.scheduleMenuFeature
            : {}),
          items: {
            ...(_ctx.schedulerProConfig?.scheduleMenuFeature?.items
              ? _ctx.schedulerProConfig.scheduleMenuFeature.items
              : {}),
            showProcesses:
              _ctx.currentMode === 'visitor'
                ? {
                    ...(_ctx.schedulerProConfig.scheduleMenuFeature?.items?.showProcesses
                      ? _ctx.schedulerProConfig.scheduleMenuFeature?.items?.showProcesses
                      : {}),
                    onItem: _ctx.showProcessesOnMenu,
                  }
                : false,
            hideProcesses:
              _ctx.currentMode === 'visitor'
                ? {
                    ...(_ctx.schedulerProConfig.scheduleMenuFeature?.items?.hideProcesses
                      ? _ctx.schedulerProConfig.scheduleMenuFeature.items.hideProcesses
                      : {}),
                    onItem: _ctx.hideProcessesOnMenu,
                  }
                : false,
          },
        },
              cellMenuFeature: {
          ...(_ctx.schedulerProConfig?.cellMenuFeature ? _ctx.schedulerProConfig.cellMenuFeature : {}),
          items: {
            ...(_ctx.schedulerProConfig?.cellMenuFeature?.items
              ? _ctx.schedulerProConfig.cellMenuFeature.items
              : {}),
            showProcesses:
              _ctx.currentMode === 'visitor' && _ctx.schedulerProConfig.cellMenuFeature
                ? {
                    ...(_ctx.schedulerProConfig.cellMenuFeature?.items.showProcesses
                      ? _ctx.schedulerProConfig.cellMenuFeature.items.showProcesses
                      : {}),
                    onItem: _ctx.showProcessesOnMenu,
                  }
                : false,
            hideProcesses:
              _ctx.currentMode === 'visitor'
                ? {
                    ...(_ctx.schedulerProConfig?.cellMenuFeature?.items?.hideProcesses
                      ? _ctx.schedulerProConfig.cellMenuFeature.items.hideProcesses
                      : {}),
                    onItem: _ctx.hideProcessesOnMenu,
                  }
                : false,
          },
        }
            }), null, 16, ["resources", "events", "dependencies", "onEventClick", "onEventDblClick", "onDataChange", "onCellDblClick", "onCellClick", "onWheel", "eventMenuFeature", "scheduleMenuFeature", "cellMenuFeature"])),
        _createVNode(_component_EventEditor, {
          mode: _ctx.eventEditorMode,
          eventRecord: _ctx.eventRecord,
          scheduler: _ctx.getSchedulerPro(),
          onSaveEvent: _ctx.saveEvent,
          onCancelEdit: _ctx.cancelEdit,
          now: _ctx.eventNow,
          onCommentAdded: _ctx.handleCommentAdded,
          onCommentDeleted: _ctx.handleCommentDeleted,
          onNameEdited: _ctx.handleNameEdited,
          projectDurationSettings: _ctx.projectDurationSettings
        }, null, 8, ["mode", "eventRecord", "scheduler", "onSaveEvent", "onCancelEdit", "now", "onCommentAdded", "onCommentDeleted", "onNameEdited", "projectDurationSettings"]),
        _createVNode(_component_NotificationsTW, {
          show: _ctx.openAlert,
          alert: _ctx.alert,
          onCloseAlert: _cache[20] || (_cache[20] = ($event: any) => (_ctx.openAlert = false))
        }, null, 8, ["show", "alert"]),
        _createVNode(_component_PdfExportModal, {
          open: _ctx.isPdfExportModalOpen,
          onCanceled: _cache[21] || (_cache[21] = ($event: any) => (this.isPdfExportModalOpen = false)),
          onConfirmed: _ctx.exportPdf
        }, null, 8, ["open", "onConfirmed"]),
        _createVNode(_component_MilestonePlotModal, {
          open: _ctx.milestonePlotOpen,
          onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.milestonePlotOpen = false))
        }, null, 8, ["open"]),
        _createVNode(_component_ProcessSideBar, {
          open: _ctx.isProcessSideBarOpen,
          onClosed: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isProcessSideBarOpen = false)),
          processes: _ctx.processSideBarProcesses,
          resourceFullName: _ctx.processSideBarResourceFullName
        }, null, 8, ["open", "processes", "resourceFullName"]),
        _createVNode(_component_ActualSideBar, {
          open: _ctx.isActualSideBarOpen,
          onClosed: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isActualSideBarOpen = false)),
          cameraList: _ctx.sourceCamerasList,
          resourceFullName: _ctx.actualSideBarResourceFullName,
          sourceId: _ctx.eventDblClickSourceId,
          events: _ctx.eventsOfResource,
          onCommentAdded: _ctx.handleCommentAdded,
          onCommentDeleted: _ctx.handleCommentDeleted,
          projectDurationSettings: _ctx.projectDurationSettings
        }, null, 8, ["open", "cameraList", "resourceFullName", "sourceId", "events", "onCommentAdded", "onCommentDeleted", "projectDurationSettings"])
      ])
    ]),
    _: 1
  }, 8, ["activeTag"]))
}